import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Gastronomia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-sage-light to-beige-light">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/gastronomia-hero.jpg')`,
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-title font-bold text-white mb-6">
              Gastronomia Artigianale a domicilio o con ritiro
            </h1>
            <p className="text-lg md:text-2xl font-body text-white max-w-3xl mx-auto">
              Piatti pronti di qualità per semplificare la tua vita
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-title font-bold text-sage-dark mb-6">
                La Mia Mission
              </h2>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                <strong>Semplificare e ottimizzare la tua vita in cucina,</strong> senza rinunciare alla qualità e al gusto. 
Acquolina nasce dall'idea di portare la mia cucina a casa tua: che sia per una coccola di gusto o per alleggerirti dallo stress di decidere e di preparare il pranzo o la cena.
              </p>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                Cucino per te nel mio laboratorio e consegno a casa tua piatti pronti, semplici e naturali, che mantengono intatte tutte le proprietà nutritive e organolettiche.
              </p>
              <p className="text-lg font-body text-neutral-600 mb-16 leading-relaxed">
                Ogni piatto è preparato con ingredienti selezionati e di prima scelta, confezionati in atmosfera modificata per garantire freschezza e durata. Grazie a questo metodo di conservazione potrai fare il tuo ordine pensando all'organizzazione dei pasti di tutta la settimana: la praticità incontra la qualità.
                </p>
              <p className="text-lg font-body text-neutral-600 mb-6 leading-relaxed">
                Puoi consultare il menu e fare il tuo ordine dal link qui sotto, ma se hai dubbi o domande sono a disposizione tramite WhatsApp.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="https://48ig4en6nuwn8uwrecno4owo7qy6lua4.pwa.pienissimo.pro/home?hashform=48ig4en6nuwn8uwrecno4owo7qy6lua4"
                  className="bg-sage-dark hover:bg-sage-medium text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ordina Ora
                </a>
                <a 
                  href="https://wa.me/393458279163?text=Ciao, ho visto il tuo sito ACQUOLINA e vorrei maggiori informazioni sui tuoi servizi."
                  className="border-2 border-sage-dark hover:bg-sage-dark hover:text-white text-sage-dark px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Scrivimi su WhatsApp
                </a>
              </div>
            </div>
            <div>
              <div 
                className="rounded-3xl shadow-2xl h-96 bg-cover bg-center"
                style={{
                  backgroundImage: `url('/images/gastronomia-mission.jpg')`,
                  backgroundPosition: '50% 35%'}}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-beige-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Cosa offre il servizio di gastronomia
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto">
              Servizi pensati per tutte le esigenze
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Produzione Artigianale */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Produzione Artigianale
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Ogni piatto è preparato a mano nel mio laboratorio seguendo 
                ricette tradizionali e utilizzando tecniche artigianali che 
                preservano sapori e proprietà nutritive.
              </p>
            </div>

            {/* Confezionamento ATM */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Confezionamento ATM
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Ho scelto la tecnologia dell'atmosfera modificata (ATM) per garantire massima freschezza e durata, mantenendo intatte le caratteristiche organolettiche di ogni preparazione.
I prodotti confezionati in ATM, infatti, possono durare fino a 10 giorni in frigorifero.
              </p>
            </div>

            {/* Consegna Settimanale */}
            <div className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="mb-6">
                <svg className="w-16 h-16 text-sage-dark mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3 className="text-2xl font-title font-bold text-sage-dark mb-4">
                Consegna Settimanale
              </h3>
              <p className="font-body text-neutral-600 leading-relaxed">
                Ogni giovedì troverai un nuovo menu sull’applicazione Acquolina, scaricabile dal pulsante "ordina ora". Dal giovedì al sabato hai tempo per pensare e fare il tuo ordine. Lunedì e martedì effettuerò le consegne. Ricevi i tuoi piatti preferiti a casa tua o ritirali presso la pasticceria “La Dolce Pausa” di Colzate in via Roma 56/a. 
                <br />
                Programma la tua settimana grazie alle mie consegne regolari!

              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-sage-dark text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold mb-6">
              Come Funziona
            </h2>
            <p className="text-xl font-body opacity-90 max-w-3xl mx-auto">
              Un processo semplice per portare la mia cucina a casa tua
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-title font-bold mb-4">Ordina</h3>
              <p className="font-body opacity-90">
                Dal giovedì al sabato scegli i tuoi piatti preferiti dal menu che trovi sull’applicazione e pianifica la tua consegna o ritiro (lunedì e martedì in giornata)
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-title font-bold mb-4">Preparazione</h3>
              <p className="font-body opacity-90">
                Cucino personalmente ogni piatto nel mio laboratorio con ingredienti freschi e selezionati
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-title font-bold mb-4">Consegna o ritiro</h3>
              <p className="font-body opacity-90">
                Lunedì e martedì consegno i piatti a casa tua o ritirali al punto di ritiro a Colzate presso la Pasticceria “La Dolce Pausa”
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <a 
              href="https://48ig4en6nuwn8uwrecno4owo7qy6lua4.pwa.pienissimo.pro/home?hashform=48ig4en6nuwn8uwrecno4owo7qy6lua4"
              className="bg-white text-sage-dark hover:bg-beige-light px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ordina Ora
            </a>
          </div>
        </div>
      </section>

      {/* Image Placeholder Section */}
      <section className="py-20 bg-beige-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-title font-bold text-sage-dark mb-6">
              Le Mie Preparazioni
            </h2>
            <p className="text-xl font-body text-neutral-600 max-w-3xl mx-auto mb-8">
              Ogni piatto racconta una storia di passione e qualità
            </p>
            <div className="bg-white rounded-3xl p-12 shadow-xl">
              <div className="border-2 border-dashed border-sage-light rounded-xl p-8 text-center">
                <svg className="w-16 h-16 text-sage-medium mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <h3 className="text-xl font-title font-semibold text-sage-dark mb-2">
                  Foto Professionali in Arrivo
                </h3>
                <p className="font-body text-neutral-600">
                
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gastronomia;